import * as React from "react";
import {ClientMessageRoomsState} from "../../../../store/client_message_rooms_state";
import {IClientMessageRoomsDispatcher} from "../../../../dispatcher/client_message_rooms_dispatcher";
import ClientMessageRoomCards from "./client_message_room_cards";


interface IProps {
    messageRoomsState: ClientMessageRoomsState,
    messageRoomsDispatcher: IClientMessageRoomsDispatcher,
    isMessageRooms: boolean,
}

const ClientMessageRoomsLeft: React.FC<IProps> = (props) => {

    const {messageRoomsState, isMessageRooms} = props;
    const {messageRooms, customers, projects, latestMessages} = messageRoomsState

    const {initialMessageRoom} = messageRoomsState;

    return (
        <React.Fragment>
            <ClientMessageRoomCards
                messageRooms={messageRooms}
                customers={customers}
                projects={projects}
                latestMessages={latestMessages}
                isMessageRooms={isMessageRooms}
                initialMessageRoom={initialMessageRoom}
                />
        </React.Fragment>
    )
}

export default ClientMessageRoomsLeft


// WEBPACK FOOTER //
// ./src/presentation/component/client/message_rooms/left/client_message_rooms_left.tsx